import { createContext, useContext, useState, ReactNode, useEffect } from 'react';

interface MobileUIContextType {
  hideNavigation: boolean;
  setHideNavigation: (hide: boolean) => void;
}

const MobileUIContext = createContext<MobileUIContextType>({
  hideNavigation: false,
  setHideNavigation: () => {}
});

export function MobileUIProvider({ children }: { children: ReactNode }) {
  const [hideNavigation, setHideNavigation] = useState(false);
  
  // Cleanup on unmount
  useEffect(() => {
    return () => setHideNavigation(false);
  }, []);
  
  return (
    <MobileUIContext.Provider value={{ hideNavigation, setHideNavigation }}>
      {children}
    </MobileUIContext.Provider>
  );
}

export function useMobileUI() {
  return useContext(MobileUIContext);
}
